import { FaIcon } from '@ifixit/ui/components/icon';
import { SurveyPopUpData } from './SurveyPopUpData';
import { useEffect, useState } from 'react';
import { markClickedToTakeSurvey } from './RecentSurveys';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

type TrackSurveyParams = {
   id: string;
   title: string;
   click: boolean;
};

const trackSurveyEvent = ({ id, title, click }: TrackSurveyParams) => {
   const action = click ? 'Button - Click' : 'View';
   const capitalizedId = id.charAt(0).toUpperCase() + id.slice(1);
   trackAnalyticsCustomEvent({
      eventCategory: `Survey Pop Up - ${capitalizedId}`,
      eventAction: `Survey Pop Up - ${capitalizedId} - ${action}`,
      eventName: `Survey - ${title}`,
   });
};

interface MarkSurveySeen {
   markSurveySeen: () => void;
}

type SurveyPopUpProps = SurveyPopUpData & MarkSurveySeen;

export const SurveyPopUp = ({ id, title, description, link, markSurveySeen }: SurveyPopUpProps) => {
   const [isClosed, setIsClosed] = useState(false);

   const onClose = () => {
      setIsClosed(true);
   };
   const clickSurvey = () => {
      window.location.href = link;
      markClickedToTakeSurvey(id);
      trackSurveyEvent({ id, title, click: true });
   };

   const viewSurvey = () => {
      markSurveySeen();
      trackSurveyEvent({ id, title, click: false });
   };

   useEffect(viewSurvey, []);

   return (
      <>
         {!isClosed && (
            <div
               id="survey-pop-up"
               className="fixed bottom-[15px] right-[15px] left-[15px] z-[9] flex w-auto flex-col gap-3 rounded border border-gray-300 bg-white p-4 text-center shadow-md sm:bottom-5 sm:right-5 sm:left-auto sm:w-80 sm:p-6"
            >
               <h4 className="m-0 text-xl font-medium leading-normal text-black">{title}</h4>
               <button
                  type="button"
                  aria-label="Close"
                  className="absolute top-[18px] right-[18px] text-gray-400"
                  onClick={onClose}
               >
                  <FaIcon name="xmark" className="size-5" />
               </button>
               <p className="m-0 text-gray-500">{description}</p>
               <button
                  type="button"
                  id="take-survey-button"
                  className="mx-auto inline-flex items-center justify-center h-9 px-4 rounded-lg bg-brand-500 text-white hover:bg-brand-600 font-semibold transition-colors cursor-pointer"
                  onClick={clickSurvey}
               >
                  Take the Survey
               </button>
            </div>
         )}
      </>
   );
};
